"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordCheckSchema = exports.SessionsInfoSchema = exports.SessionInfoSchema = void 0;
// src/dto/SessionInfoDTO.ts
const ESessionStatus_1 = require("./ESessionStatus");
const zod_1 = require("zod");
const PasswordCheckSchema = zod_1.z.object({
    IsOK: zod_1.z.boolean(),
});
exports.PasswordCheckSchema = PasswordCheckSchema;
const SessionInfoSchema = zod_1.z.object({
    Id: zod_1.z.number(),
    Name: zod_1.z.string(),
    Status: zod_1.z.nativeEnum(ESessionStatus_1.ESessionStatus),
    Date: zod_1.z.date(),
    AnimatorName: zod_1.z.string(),
    AnimatorEmail: zod_1.z.string(),
    AnimatorId: zod_1.z.string(),
    AnimatorStructure: zod_1.z.optional(zod_1.z.string()),
    DeckId: zod_1.z.number(),
    Language: zod_1.z.string(),
    Comment: zod_1.z.string(),
    Code: zod_1.z.string(),
});
exports.SessionInfoSchema = SessionInfoSchema;
const SessionsInfoSchema = zod_1.z.array(SessionInfoSchema);
exports.SessionsInfoSchema = SessionsInfoSchema;
